/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Box_Label_Print_BtnInputs */

const vi_box_label_print_btn = /** @type {(inputs: Box_Label_Print_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In nhãn thùng`)
};

/**

* @param {Box_Label_Print_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const box_label_print_btn = /** @type {((inputs?: Box_Label_Print_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Box_Label_Print_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_box_label_print_btn(inputs)
});